/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Sample_ApprovedInputs */

const en_samples_edit_sample_approved = /** @type {(inputs: Samples_Edit_Sample_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample approved`)
};

const es_samples_edit_sample_approved = /** @type {(inputs: Samples_Edit_Sample_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra aprobada`)
};

/**
* | output |
* | --- |
* | "Sample approved" |
*
* @param {Samples_Edit_Sample_ApprovedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_sample_approved = /** @type {((inputs?: Samples_Edit_Sample_ApprovedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Sample_ApprovedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_sample_approved(inputs)
	return es_samples_edit_sample_approved(inputs)
});